export const authConstants = {
    LOAD_AUTH_CODE_LIST_REQUEST: 'LOAD_AUTH_CODE_LIST_REQUEST',
    LOAD_AUTH_CODE_LIST_SUCCESS: 'LOAD_AUTH_CODE_LIST_SUCCESS',
    LOAD_AUTH_CODE_LIST_FAILURE: 'LOAD_AUTH_CODE_LIST_FAILURE',

    CREATE_AUTH_CODE_REQUEST: 'CREATE_AUTH_CODE_REQUEST',
    CREATE_AUTH_CODE_SUCCESS: 'CREATE_AUTH_CODE_SUCCESS',
    CREATE_AUTH_CODE_FAILURE: 'CREATE_AUTH_CODE_FAILURE',
};
